import { Injectable } from '@angular/core';
import { CanActivateChild, Router, UrlTree } from '@angular/router';
import { AbilityService } from 'ability';
import { RoutingPath } from 'mbs-ui-shared/src/lib/constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardGuard implements CanActivateChild {
  constructor(private ability: AbilityService, private router: Router) {}

  canActivateChild(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.router.createUrlTree([this.ability.can('read', 'NewDashboardPage') ? RoutingPath.ApDashboard : RoutingPath.ApDefaultAspx]);
  }
}
